var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebook(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 .04a9 9 0 00-9 9c0 4.457 3.245 8.15 7.499 8.864v-6.987H5.328V8.402h2.171V6.548c0-2.15 1.314-3.323 3.233-3.323.92 0 1.71.068 1.939.098v2.25H11.34c-1.044 0-1.245.496-1.245 1.223v1.605h2.49l-.325 2.514h-2.165v7.05C14.548 17.421 18 13.635 18 9.036 18 4.069 13.97.039 9 .039z",
    fill: "currentColor"
  })));
}
export default SvgFacebook;